import { Component } from 'react'

class ScrollHandler extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isScrolled: false,
        }

        this.handleScroll = this.handleScroll.bind(this)

        window.addEventListener('scroll', this.handleScroll)
    }

    componentDidMount() {
        const isScrolled = this.isScrolledPastBreakpoint()
        if (isScrolled) {
            this.handleScroll()
        }
    }

    isScrolledPastBreakpoint() {
        const scrollTop =
            document.querySelector('html').scrollTop ||
            document.querySelector('body').scrollTop
        return scrollTop > this.props.breakpoint
    }

    handleScroll() {
        const isScrolled = this.isScrolledPastBreakpoint()
        if (isScrolled !== this.state.isScrolled) {
            this.setState({ isScrolled })
            this.props.onBreakpoint(isScrolled)
        }
    }

    render() {
        return null
    }
}

export default ScrollHandler
